import React, {useEffect, useRef} from "react";
import { createRoot } from "react-dom/client"

export default function CustomMarker ( { map, children, position, showMarker, onClick } ) {
    const markerRef = useRef();
    const rootRef = useRef();

    useEffect(() => {
        if (!rootRef.current) {
            if ( Number.isNaN(position?.lat) || Number.isNaN(position?.lng) ){
                return
            }

            const container = document.createElement("div");
            rootRef.current = createRoot(container);
            markerRef.current = new window.google.maps.marker.AdvancedMarkerView({
                position : position
                , content : container
            });
        }
    }, []);

    useEffect(() => {
        if ( Number.isNaN(position?.lat) || Number.isNaN(position?.lng) ){
            return
        }

        rootRef.current.render(children);
        markerRef.current.position = position;
        markerRef.current.map = showMarker ? map : null;
        const listener = markerRef.current.addListener('click', onClick);
    }, [map, children, position]);
}